import request from '@/utils/request'


//获取All courses，pageindex从0开始
//返回值中的State字段: 0未订阅 1已订阅
export function getCourse (pageIndex,pageSize) {
  return request({
    url: `/api/Training/GetCourse?pageIndex=${pageIndex}&pageSize=${pageSize}`,
    method: 'post'
  })
}
//获取My courses，pageindex从0开始
//返回值中的State字段: 0 pending,1 ongoing , 2 completed
export function getMyCourse (pageIndex,pageSize) {
  return request({
    url: `/api/Training/GetMyCourse?pageIndex=${pageIndex}&pageSize=${pageSize}`,
    method: 'post'
  })
}
//获取课程详细
//返回值中的State字段: 0未订阅 1已订阅
//LearnState:0未学习 1学习中 2已学习
export function getDetail (courseId) {
  return request({
    url: `/api/Training/getDetail?courseId=${courseId}`,
    method: 'post'
  })
}
//订阅课程
//ErrorCode==0订阅成功,其它失败
export function subscribe (courseId) {
  return request({
    url: `/api/Training/Subscribe?courseId=${courseId}`,
    method: 'post'
  })
}
//开始学习章节，chapterId：章节的ID
//ErrorCode==0成功学习,其它失败
export function learnning (chapterId) {
  return request({
    url: `/api/Training/Learnning?chapterId=${chapterId}`,
    method: 'post'
  })
}
// 获取章节的状态
export function trakitStatusByTuid (trakitId) {
  return request({
    url: `/api/Training/TrakitStatusByTuid?trakitId=${trakitId}`,
    method: 'post'
  })
}
// GetTeachableSubjects
export function getTeachableSubjects () {
  return request({
    url: `/api/Training/GetTeachableSubjects`,
    method: 'post'
  })
}
// Process Training List
export function getPTInfoByTuid () {
  return request({
    url: `/api/Training/GetPTInfoByTuid`,
    method: 'post'
  })
}
// GetProcessTrainingTimeList
export function getProcessTrainingTimeList (ScheduleStart,ScheduleEnd) {
  return request({
    url: `/api/Training/GetProcessTrainingTimeList?ScheduleStart=${ScheduleStart}&ScheduleEnd=${ScheduleEnd}`,
    method: 'post'
  })
}
// AppointmentTraining
export function appointmentTraining (ScheduleStart,ScheduleEnd,Remark,TUName) {
  return request({
    url: `/api/Training/AppointmentTraining?ScheduleStart=${ScheduleStart}&ScheduleEnd=${ScheduleEnd}&Remark=${Remark}&TUName=${TUName}`,
    method: 'post'
  })
}
// 获取培训资源
export function getSelfStudySource (traKitId) {
  return request({
    url: `/api/Training/GetSelfStudySource?traKitId=${traKitId}`,
    method: 'post'
  })
}

// 下载培训资源
export function downloadSelfStudySource (traKitId) {
  return request({
    url: `/api/Training/DownloadSelfStudySource`,
    method: 'post',
    data: {
      traKitId
    },
    responseType: 'blob' 
  })
}
// Trial Class Training
export function getTrialClassTraining (pageIndex, pageSize) {
  return request({
    url: `/api/Training/GetTutorTrailClassList`,
    method: 'post',
    data: {
      pageIndex, pageSize
    }
  })
}

// 进入培训室
export function getTrailCourseClassroomUrl (isclient) {
  return request({
    url: `/api/Training/GetTrailCourseClassroomUrl?isclient=${isclient}`,
    method: 'post'
  })
}

export function getChangeGroupTips (id) {
  return request({
    url: `/api/Training/GetChangeGroupTips?id=${id}`,
    method: 'post'
  })
}
// 所有培训
export function getAllTrainingList (PageIndex,PageSize) {
  return request({
    url: `/api/Training/GetAllTrainingList?PageIndex=${PageIndex}&PageSize=${PageSize}`,
    method: 'post'
  })
}
// PT-QA Demo取消
export function cancelQALessonInfo (ID,DeletedDesc) {
  return request({
    url: `/api/Training/CancelQALessonInfo`,
    method: 'post',
    data:{
      ID,
      DeletedDesc
    }
  })
}
//  MT-QA Demo取消
export function cancelTestLesson (ID,DeletedDesc) {
  return request({
    url: `/api/Training/CancelTestLesson`,
    method: 'post',
    data:{
      ID,
      DeletedDesc
    }
  })
}
// MT培训提交评价
export function trainingEvaluation (tranCourseId,evaluationRequest) {
  return request({
    url: `/api/Training/TrainingEvaluation`,
    method: 'post',
    data:{tranCourseId,evaluationRequest}
  })
}
// MT培训查看评价
export function getTrainingEvaluationRecord (TranCourseId) {
  return request({
    url: `/api/Training/GetTrainingEvaluationRecord?TranCourseId=${TranCourseId}`,
    method: 'post'
  })
}
// 老师当前是否有未完成的培训课程评价
export function getIsUnfinishedEvalution () {
  return request({
    url: `/api/Training/GetIsUnfinishedEvalution`,
    method: 'post'
  })
}
// 
export function getKctListByName (name,uuid) {
  return request({
    url: `/api/Training/GetKctListByName?name=${name}&guid=${uuid}`,
    method: 'post'
  })
}
// 
export function getCourseHomeInfo () {
  return request({
    url: `/api/Training/GetCourseHomeInfo`,
    method: 'post'
  })
}
// MT-QA培训 获取QA评分详情
export function getTLResultDetail (trainingId,trainingType) {
  return request({
    url: `/api/Training/GetTLResultDetail?trainingId=${trainingId}&trainingType=${trainingType}`,
    method: 'post'
  })
}
//
export function getRecentTrainingAnnouncementList () {
  return request({
    url: `/api/Training/GetRecentTrainingAnnouncementList`,
    method: 'post'
  })
}
//
export function getTrainingAnnouncementById (id) {
  return request({
    url: `/api/Training/GetTrainingAnnouncementById?id=${id}`,
    method: 'post'
  })
}
export function getTrainByTaskLevel (level,type) {
  return request({
    url: `/api/Training/GetTrainByTaskLevel?level=${level}&type=${type}`,
    method: 'post'
  })
}

export function addClickRecord (data) {
  return request({
    url: `/api/Training/AddClickRecord`,
    method: 'post',
    data: data
  })
}

export function getAExcellentTrainingCases() {
  return request({
    url: `/api/Training/GetMyCoursesAndRemindByCategoryType?categoryType=9`,
    method: 'get'
  })
}
